import { ReactElement } from 'react';

import { Country, Postcode } from '@dreryk/address-common-api';

import { BindingCreator, commonTranslationKeys, ValidationRules } from '@dreryk/react-common';
import { PostcodeInput } from '@dreryk/react-components';

import { PatientAddressFormController } from '../PatientAddressForm.types';

type PostcodeFormBeanPart = {
   postcode: Postcode | null;
};

const validationRules: ValidationRules<PostcodeFormBeanPart> = {
   maxLength: Postcode.MAX_LENGTH,
};

type PostcodeFieldProps = Pick<PatientAddressFormController, 'watch'> & {
   readonly register: BindingCreator<PostcodeFormBeanPart, 'postcode'>;
};

export const PostcodeField = (props: PostcodeFieldProps): ReactElement => {
   const country: Country | null = props.watch('country');

   return (
      <PostcodeInput
         controller={props.register('postcode', validationRules)}
         label={commonTranslationKeys.addressData.zipCode}
         countryIsoCode={country?.getIsoCode()}
         testId={'postcode'}
         className={'postcode'}
      />
   );
};
